import { Save, Loader2 } from 'lucide-react';

interface FormActionButtonsProps {
  onCancel: () => void;
  onSave: () => void;
  saving: boolean;
  saveLabel: string;
  cancelLabel?: string;
  savingLabel?: string;
}

export default function FormActionButtons({
  onCancel,
  onSave,
  saving,
  saveLabel,
  cancelLabel = 'Cancel',
  savingLabel = 'Saving...',
}: FormActionButtonsProps) {
  return (
    <div className="flex items-center gap-3">
      <button
        onClick={onCancel}
        className="px-4 py-2 text-sm font-medium text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50"
      >
        {cancelLabel}
      </button>
      <button
        onClick={onSave}
        disabled={saving}
        className="flex items-center gap-2 px-4 py-2 text-sm font-semibold text-white bg-primary-600 rounded-lg hover:bg-primary-700 disabled:opacity-50"
      >
        {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
        {saving ? savingLabel : saveLabel}
      </button>
    </div>
  );
}
